import { Link } from "react-router-dom";

import LegalPage from "../components/legal-page";

function Terms() {
  return (
    <LegalPage
      title="Terms of Service"
      description="The simple terms for reading and using AimanRe.my."
      path="/terms"
      updated="18 October 2026"
    >
      <p>
        By using this site, you agree to these terms. They are short on purpose. The goal
        is to keep this a calm, useful place for everyone who visits.
      </p>

      <h2>Use of the site</h2>
      <p>
        You are welcome to read, link to, and share what you find here. Please do not use
        the site to break the law, interfere with its operation, or attempt to access
        systems or data you are not authorised to access. That is the whole rule.
      </p>

      <h2>Content and opinions</h2>
      <p>
        Everything here is written by me and reflects my own views at the time of
        writing. I am not an expert. Articles about code, tools, or money are personal
        notes, not professional advice. If you need real advice, please ask a qualified
        professional — not a personal blog with a nice font.
      </p>

      <h2>No technical support</h2>
      <p>
        I am not a developer, programmer, or IT professional. Please do not contact me for
        technical help, code reviews, or career advice. I will not be able to help, and I
        would rather be honest about that than waste your time.
      </p>

      <h2>Intellectual property</h2>
      <p>
        The words and original images on this site belong to me unless stated otherwise.
        You may quote a short passage with a clear link back to the original article.
        Republishing substantial parts without permission is not cool.
      </p>

      <h2>Advertising and third-party links</h2>
      <p>
        This site displays advertising through Google AdSense. Ads are selected by
        advertising systems, not by me. I have as much control over them as a passenger
        in a taxi. Links to other websites are provided for convenience, and I do not
        control their content or practices. See the{" "}
        <Link to="/privacy">Privacy Policy</Link> for how advertising cookies are used.
      </p>

      <h2>Availability</h2>
      <p>
        The site is provided as-is. It may be unavailable, changed, or moved without
        notice. It may also take a nap. I do not promise that everything will always be
        accurate or complete.
      </p>

      <h2>Limitation of liability</h2>
      <p>
        To the extent allowed by law, I am not liable for any loss or damage arising from
        your use of this site or reliance on its content.
      </p>

      <h2>Changes</h2>
      <p>
        These terms may be updated from time to time. The latest version will always be
        on this page, with the date above, like a receipt.
      </p>

      <h2>Contact</h2>
      <p>
        If something here is unclear, message me on{" "}
        <a
          href="https://www.threads.com/@muhdaimanrs"
          target="_blank"
          rel="noopener noreferrer"
        >
          Threads
        </a>{" "}
        or{" "}
        <a href="https://x.com/muhdaimanrs" target="_blank" rel="noopener noreferrer">
          X
        </a>
        . I will reply when I can, probably with coffee nearby.
      </p>
    </LegalPage>
  );
}

export default Terms;
